(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumea-reviews"] && !Shopify.designMode) return;
  try {
    
function arrangeLumeaReviews(root){const grid=root.querySelector('.lrv-grid');if(!grid)return;let queued=false;const arrange=()=>{queued=false;const mobile=matchMedia('(max-width:749px)').matches;const cols=mobile?2:4;const gap=mobile?12:20;const width=(grid.clientWidth-gap*(cols-1))/cols;if(width<=0)return;const heights=Array(cols).fill(0);grid.dataset.masonry='';for(const card of grid.children){card.style.width=width+'px';const col=heights.indexOf(Math.min(...heights));card.style.transform=`translate(${col*(width+gap)}px,${heights[col]}px)`;heights[col]+=card.offsetHeight+gap;}grid.style.height=Math.max(...heights)-gap+'px';};const schedule=()=>{if(!queued){queued=true;requestAnimationFrame(arrange);}};root.querySelectorAll('img').forEach(img=>{img.addEventListener('load',schedule);img.addEventListener('error',schedule);});new ResizeObserver(schedule).observe(root);document.fonts.ready.then(schedule);arrange();}
document.querySelectorAll('.lrv').forEach(arrangeLumeaReviews);document.addEventListener('shopify:section:load',event=>{event.target.querySelectorAll('.lrv').forEach(arrangeLumeaReviews);});

  } catch(e) { console.error(e); }
})();
})();
